<template>
    <div v-if="pageRender" class="entry-page">
        <!--    基本信息录入    -->
        <BasicInfo></BasicInfo>

        <!--    房屋勘测详情     -->
        <RoomProspectDetail @confirmEnd="getEntryReport"></RoomProspectDetail>

        <!--    初步配置推荐    -->
        <ConfigRecommend></ConfigRecommend>

        <!--      设备配置     -->
        <MachineConfig></MachineConfig>

        <!--    上传设计图    -->
        <div class="update-design-image">
            <BasicTitle title="上传设计图"></BasicTitle>
            <div class="image-list">
                <VantUploader class="image-item" :afterRead="uploadImageToList" :maxCount="1">
                    <img class="icon" :src="require('@/assets/images/hvac/mapping/image-add-icon.png')" alt=""/>
                </VantUploader>
                <div v-for="item in uploadImageList" :key="item.img_url" class="image-item">
                    <img class="close" :src="require('@/assets/images/hvac/mapping/reduce-icon.png')" alt="" @click.stop="removeImgToList(item)"/>
                    <img :src="item.img_url" alt=""/>
                </div>
            </div>
        </div>
        <!--    系统设备定位 按钮    -->
        <div class="system-position" @click="reportComplete">完成</div>

        <!--        <Dialog :show="true">当前报告不可编辑</Dialog>-->
    </div>
</template>

<script>
import BasicInfo from "./components/basicinfo";
import RoomProspectDetail from "./components/roomprospectdetail";
import ConfigRecommend from "./components/configrecommend";
import MachineConfig from "./components/machineconfig";
import BasicTitle from "./components/basictitle";
import {mapState} from "vuex";
import {uploadImage} from "@/js/hvac/mapping";
import {Uploader} from 'vant';
import {fetchVerifyAuthForB} from '@/libsV2/havc'

const {Toast} = require("vant");


export default {
    name: "entry",
    data() {
        return {
            // 潜客ID
            accountId: "",
        };
    },
    components: {
        BasicTitle,
        BasicInfo,
        RoomProspectDetail,
        ConfigRecommend,
        MachineConfig,
        VantUploader: Uploader,
        // Dialog
    },

    created() {
        fetchVerifyAuthForB(() => {
            this.getAccountId();
            this.getSignHandInfo();
            this.getEntryReport();
        });
    },
    computed: {
        ...mapState({
            // 报告是否可编辑
            pageRender: (state) => state.hvacMappingEntry.pageRender,
            // 设计图列表
            uploadImageList: (state) => state.hvacMappingEntry.uploadImageList,
        }),
    },
    beforeRouteEnter(to, from, next) {
        !to.query.accountId ? Toast('参数错误', {duration: null}) : next();
    },
    methods: {

        /**
         * 添加一张图片(设计图)
         */
        async uploadImageToList({content} = {}) {
            const {data: {result: {media_url, local_url}}} = await uploadImage({file: content});
            const data = {
                img: local_url,
                img_url: media_url
            };
            this.uploadImageList.push(data);
            await this.$store.dispatch({type: 'hvacMappingEntry/uploadReportDesignImage'});

        },
        // 点击图片右上角的删除触发的函数
        removeImgToList(item) {
            this.$store.commit({type: 'hvacMappingEntry/SAVE_UPLOAD_IMAGE_LIST', list: this.uploadImageList.filter(i => i.img_url !== item.img_url)});
            this.$store.dispatch({type: 'hvacMappingEntry/uploadReportDesignImage'});
        },
        /**
         * 获取潜客ID
         */
        getAccountId() {
            // 后期从路由带入
            this.accountId = this.$route.query.accountId;
        },
        /**
         * 获取签单手信息
         */
        getSignHandInfo() {
            this.$store.dispatch({type: "hvacMappingEntry/getSysUserInfo"});
        },
        /**
         * 获取勘察报告详情
         */
        getEntryReport() {
            this.$store.dispatch({
                type: "hvacMappingEntry/getEntryReportIndex",
                accountId: this.accountId,
            });
        },
        /**
         * 报告完成点击
         */
        reportComplete() {
            this.$store.dispatch({type: 'hvacMappingEntry/reportCompleteFet'}).then(({contract_id, id}) => {
                this.$router.push({path: '/member/project/mapping', query: {contract_id, id}});
            })
        }
    },
};
</script>

<style scoped lang="scss">
.entry-page {
    background: #f0f4f1;
    padding: 24px 24px 48px;
    font-size: $baseSize;
    color: $commonText;


    .update-design-image {
        padding: 32px 24px 28px;
        background: #ffffff;
        border-radius: $commonText;

        .image-list {
            padding-top: 24px;
            display: flex;
            align-items: center;
            overflow-x: auto;

            .image-item {
                flex: 0 0 158px;
                height: 158px;
                width: 158px;
                display: flex;
                align-items: center;
                position: relative;
                justify-content: center;
                margin-right: 20px;
                background: #f3f3f3;

                img {
                    max-width: 100%;
                    height: 100%;
                }

                .icon {
                    width: 46px;
                    height: 46px;
                }

                .close {
                    width: 32px;
                    height: 32px;
                    position: absolute;
                    top: -16px;
                    right: -16px;
                }

                &:last-child {
                    margin-right: 0;
                }

                input {
                    display: inline-block;
                    position: absolute;
                    height: 158px;
                    width: 158px;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    opacity: 0;
                }
            }
        }
    }

    .system-position {
        height: 100px;
        line-height: 100px;
        text-align: center;
        border-radius: $commonRadius;
        background: $greenGradient;
        color: #ffffff;
        font-size: 32px;
        font-weight: 500;
        margin-top: 28px;
    }
}
</style>
